module.exports = __webpack_public_path__ + "img/icon-twitter.e2633f23.svg";